import styled from 'styled-components';

export const AccordionContainer = styled.div`
  margin: 2rem 0;
`;
